/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from "react";
import {
  SpotterEmbed,
  EmbedEvent,
} from "@thoughtspot/visual-embed-sdk";

import { useNavigate, useLocation } from "react-router-dom";

import { initTs, getUserSessionItem } from "../..";
import { useAppSelector } from "../../app/hooks";
import { selectUserAuthContext } from "../../features/console/consoleSlice";
import { useLazyGetTSAccessTokenQuery } from "../../services/serverless";
import { sessionChecker } from "../../helpers/session";

interface SpotterPageProps {
  orgId: number;
  worksheetId: string;
}

export const AppSpotterEmbedWrapper: React.FC<SpotterPageProps> = ({
  orgId,
  worksheetId,
}) => {
  const ref = useRef<HTMLDivElement>(null);

  const navigate = useNavigate();
  const location = useLocation();

  const userAuthContext = useAppSelector(selectUserAuthContext);
  const [getTSAccessToken] = useLazyGetTSAccessTokenQuery();

  const [isReady, setIsReady] = useState(false);
  const [error, setError] = useState<any>(null);

  // INIT + AUTH (same as AppEmbed)
  useEffect(() => {
    const initialize = async () => {
      try {
        await sessionChecker(() => {
          navigate(
            `/login?redirect_uri=${encodeURIComponent(
              `${location.pathname}${location.search}`
            )}`
          );
        });

        // Token backend
        await getTSAccessToken(orgId).unwrap();

        // Init ThoughtSpot
        await initTs(
          "TOKEN",
          userAuthContext?.userName ??
            getUserSessionItem("userName"),
          orgId
        );

        setIsReady(true);
      } catch (e) {
        console.error("❌ Init error:", e);
        setError(e);
      }
    };

    initialize();
  }, []);

  // SPOTTER EMBED
  useEffect(() => {
    if (!isReady || !ref.current) return;

    const embed = new SpotterEmbed(ref.current, {
      worksheetId: worksheetId,

      // CHAT HISTORY
      enablePastConversationsSidebar: true,

      // Layout
      frameParams: {
        width: "100%",
        height: "100%",
      }
    });

    embed
      .on(EmbedEvent.Init, () => {
        console.log("✅ Spotter Init");
      })
      .on(EmbedEvent.Load, () => {
        console.log("✅ Spotter Loaded");
      })
      .on(EmbedEvent.Error, (err) => {
        console.error("❌ Spotter Error", err);
        setError(err);
      })
      .render();

    return () => {
      embed.destroy();
    };
  }, [isReady]);

  // UI STATES

  if (error) {
    return (
      <div style={{ padding: 20 }}>
        <h3>Error cargando Spotter</h3>
        <pre>{JSON.stringify(error, null, 2)}</pre>
      </div>
    );
  }

  if (!isReady) {
    return (
      <div style={{ padding: 20 }}>
        <h3>Cargando Spotter...</h3>
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100vh",
        width: "100%",
      }}
    >
      <div
        ref={ref}
        style={{
          height: "100%",
          width: "100%",
        }}
      />
    </div>
  );
};